/* eslint-disable complexity */
/* eslint-disable no-console */
/**
 * 聊天会话主要组件
 * @author sunzhiguang
 * @date 2020/6/16
 */
/* eslint max-params: off */

import React, { useReducer, useState, useMemo, useEffect, useCallback, useContext } from "react";
import { ExclamationOutlined } from "@/utils/antdIcon";
import Loading from "@/components/Loading";
import "./index.less";
import MessageInput, { InitImgState } from "@/components/chat/message/Input/index";
import MessageInputV2 from "@/components/chat/message/Input/indexv2";

import ChatState from "@/types/chat/State";
import { connect } from "dva";
import ChatEvent from "@/components/chat/view/ChatEvent";
import MessageBoxContainer from "@/components/chat/message/Container";
import SessionHeader from "@/components/chat/message/HeadV2";
import default_chat_png from "@/assets/img/message-bg.png";
import { useTranslation } from "react-i18next";
import { ChatMessage, Employee, GroupAttribute, Session, SessionType } from "@/types/chat";
import UpLoadFile from "./UpLoadFile";
import { createUploadTask } from "@/server/FileService";
import {
  buildFileMessageBody,
  buildImageMessageBody,
  initChatMessageInfo,
  isBannedPostGroupSession,
  getMessageTypeByText,
  buildJoyspaceLinkMessageBody,
  JouspaceLinkTypeOption,
  isCrossPlatformGroupSession,
  removeFirstOccurrence,
  getFileDownloadBzId,
  getFileDownloadBzType
} from "@/utils/chat/message";
import { lookup } from "mime-types";
import log from "@/utils/logger";
import config, { ChatConfig, getNetCheckUrl } from "@/config/config";
import DestroyMessage from "@/components/chat/message/DestroyMessage";
import Forwarding from "@/components/chat/message/Forwarding";
import ForwardSelect from "@/components/chat/message/ForwardSelect";
import { DrawTypeEnum } from "@/types/chat/enum";
import { Empty, message } from "antd";
import { takeRight, throttle } from "lodash";
import { dealImagesData, filterDirectory, filterImages, formatFileType } from "../../utils/image";
import getCurVoiceHandler from "../../handler/voiceHandler";

import {
  findUserRemarkBySession,
  isAIChatSession,
  isAINoticeSession,
  isBusinessGroup
} from "@/utils/chat/session";
import AINoticeTabHeader from "@/components/chat/message/AINoticeTabHeader";
import TopNoticeCard2Chat from "@/baseComponents/TopNoticCard2Chat";
import { FocusSDK } from "@/utils";
import GroupCard from "../../message/GroupCard";
import Context from "@/components/chat/context";
import { isGroupOrdinary } from "@/utils/chat/group";
import chatConfig from "@/components/chat/config";
import QuestionAction from "@/baseComponents/Chat/QuestionAction";
import Marquee from "./Marquee";
import IconFont from "@/components/icon";
import dayjs from "dayjs";
import { getMessageTagPageList } from "@/api/chat";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import i18n from "@/i18n";
import Bus from "@/utils/bus";
import ReactDOM from "react-dom";
import { crossAppSwitch } from "@/utils/tools";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { shareGroupspaceFiles } from "@/components/Joyspace/api/page";
import { isYearBefore } from "@/utils/date";

const style = { margin: 0 };
interface ChatMainProps {
  selectedSession: Session;
  currentEmployee: Employee;
  type?: string;
  onToggleSetup?: (type: DrawTypeEnum) => void;
  allSessionListLength: number;
  selectMore: boolean;
  loadAllSessionListEnd: boolean;
  messageInputFocus: boolean;
  showTagList: any;
  privateUser: any;
  currentAIRobot: any;
}

interface DvaDispatchProps {
  pushChatMessage: Function;
  setShowTagList: Function;
  editorMode: string;
}

type IChatMainProps = Readonly<ChatMainProps & DvaDispatchProps>;

export interface FileItem {
  title: string;
  size: number;
  fileType: string;
}
interface IState {
  fileState: FileItem;
  fileUploadModalVisible: boolean;
  file: any;
  fileList: any[];
  isPaste: boolean;
  filePath: any;
}

function reducer(state: IState, action: any) {
  const { payload } = action;
  switch (action.type) {
    case "openUploadFileModal":
      // eslint-disable-next-line no-case-declarations
      const { fileState, file, fileList, isPaste = false, filePath = null } = payload;
      return {
        ...state,
        fileUploadModalVisible: true,
        fileState,
        file,
        fileList,
        isPaste,
        filePath
      };
    case "closeUploadFileModal":
      return { ...state, fileUploadModalVisible: false };
    case "clearFileState":
      return {
        ...state,
        fileState: {},
        file: null,
        fileList: [],
        isPaste: false,
        filePath: null
      };
    default:
      throw new Error();
  }
}

const initialState: IState = {
  fileState: {
    title: "",
    size: 0,
    fileType: ""
  },
  fileUploadModalVisible: false,
  file: null,
  fileList: [],
  isPaste: false,
  filePath: null
};

// eslint-disable-next-line complexity
function ChatMain(props: IChatMainProps) {
  const {
    allSessionListLength,
    onToggleSetup,
    selectedSession,
    currentEmployee,
    selectMore,
    type,
    loadAllSessionListEnd,
    messageInputFocus,
    showTagList,
    setShowTagList,
    privateUser,
    currentAIRobot,
    editorMode = "new"
  } = props;

  const [t] = useTranslation("chat");
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { groupRosterIdentity, httpMatchUrls, blackUrls } = React.useContext(Context);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isMulti, setIsMulti] = useState(false);
  const [isEgovFile, setIsEgovFile] = useState(false);
  const [replyMessage, setReplyMessage] = useState();
  const sessionId = selectedSession.sessionId;
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });
  // 不是精简版且不是跨平台会话 才显示走马灯
  const showMarquee = crossAppSwitch("message") && !isCrossPlatformGroupSession(selectedSession);
  const [startPlay, setStartPlay] = useState(false);
  useEffect(() => {
    // 每次改变走马灯里面的标记列表内容，需要重新获取内容宽度，从而计算出动画时间
    setStartPlay(!startPlay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTagList]);

  // 关闭语音
  useEffect(() => {
    return () => {
      const voiceHandler = getCurVoiceHandler();
      voiceHandler?.destroy();
      setFileDrag(false);
    };
  }, [sessionId]);

  const setCurrentTagList = useCallback(async () => {
    const onLine = await netServer.checkNet();
    if (!onLine) {
      message.error(i18n.t("Network Error"));
      return;
    }
    const [data] = await getMessageTagPageList({
      pageNo: 1,
      pageSize: 10,
      groupId: sessionId
    });
    let tempArr: any[] = [];
    // eslint-disable-next-line array-callback-return
    data?.list &&
      Array.isArray(data?.list) &&
      data?.list.length > 0 &&
      data.list.map((item: any, index: number) => {
        // 只取前三条
        if (index < 3) {
          tempArr.push(item);
        }
        return tempArr;
      });
    setShowTagList([...tempArr]);
  }, [netServer, sessionId, setShowTagList]);

  useEffect(() => {
    if (selectedSession.isGroup) {
      setCurrentTagList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession.sessionId]);

  const handelMainWinBlur = useCallback(() => {
    setFileDrag(false);
  }, []);

  const handleEgovFileToggle = (value: boolean) => {
    setIsEgovFile(value);
  };

  useEffect(() => {
    FocusSDK.off("main-win-blur", handelMainWinBlur).on("main-win-blur", handelMainWinBlur);
    return () => {
      FocusSDK.off("main-win-blur", handelMainWinBlur);
    };
  }, [handelMainWinBlur]);

  function setCallBack(type: DrawTypeEnum) {
    if (onToggleSetup) {
      onToggleSetup(type);
    }
  }

  function handleDragEnter(e: any) {
    e.preventDefault();
    e.stopPropagation();
    // console.log('drag enter', e.dataTransfer);
  }

  function handleDragOver(e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (state.fileUploadModalVisible) {
      return;
    }
    if (!e.dataTransfer.types || !e.dataTransfer.types.includes("Files")) {
      return;
    }
    // 处理windows表情拖拽发送问题
    if (
      e.dataTransfer.types.includes("text/uri-list") &&
      e.dataTransfer.types.includes("text/html")
    ) {
      return;
    }
    // 以下过滤条件为文件往外拖
    if (e.dataTransfer.effectAllowed === "copyLink") {
      return;
    }
    setFileDrag(true);
  }

  function handleDragLeave(e: any) {
    e.preventDefault();
    e.stopPropagation();
    // console.log('drag leave', e.dataTransfer);
    setFileDrag(false);
  }

  async function handleDrop(e: any) {
    e.preventDefault();
    e.stopPropagation();
    setFileDrag(false);
    // console.log('drag drop', e.dataTransfer);
    // 禁言的会话
    if (isBannedPostGroupSession(selectedSession) && isGroupOrdinary(groupRosterIdentity)) {
      return false;
    }
    if (state.fileUploadModalVisible) {
      return;
    }
    const df = e.dataTransfer;
    if (!df.types || !df.types.includes("Files")) {
      return;
    }
    if (df.types.includes("text/uri-list") && df.types.includes("text/html")) {
      return;
    }
    // 以下过滤条件为文件往外拖
    if (df.effectAllowed === "copyLink") {
      return;
    }
    const hasItems = df.items !== undefined;
    const files = hasItems ? df.items : df.files;
    console.log("files=>", files);
    if (!files || files.length === 0) {
      return;
    }
    //  8.4.0
    // console.log('拖拽上传', files);
    if (files.length > 1) {
      let typeList: any[] = [];
      files.forEach(async (file: any) => {
        const promise = filterDirectory(file, hasItems);
        typeList.push(promise);
        // console.log('拖拽上传', typeList);
      });

      Promise.all(typeList).then((result) => {
        const isAllFile = result.every((item) => item); // 是否全部选择的文件
        if (isAllFile) {
          let effectAllFiles: any[] = [];
          if (hasItems) {
            files.forEach((item: any) => {
              effectAllFiles.push(item.getAsFile());
            });
          } else {
            effectAllFiles = files;
          }
          handleUploadFile(effectAllFiles, "multi");
        } else {
          const isAllFolder = result.every((item) => !item);
          if (isAllFolder) {
            message.warn("暂不支持发送文件夹，您可以将文件夹压缩后发送");
            return;
          } else {
            // find除文件夹之外的文件
            let effectFiles: any[] = [];
            result.forEach((item, index) => {
              if (item) {
                effectFiles.push(hasItems ? files[index].getAsFile() : files[index]);
              }
            });
            handleUploadFile(effectFiles, "multi");
          }
        }
      });
    } else {
      const file = files[0];
      const isFile = await filterDirectory(file, hasItems);
      // console.log('单选', file.getAsFile(), files);
      if (isFile) {
        handleUploadFile(hasItems ? [file.getAsFile()] : files);
      } else {
        message.warn("暂不支持发送文件夹，您可以将文件夹压缩后发送");
        return;
      }
    }
  }

  function closeUploadFileModal() {
    dispatch({ type: "closeUploadFileModal" });
    setTimeout(() => {
      dispatch({ type: "clearFileState" });
    }, 0);
    setIsEgovFile(false);
  }
  function handlePasteFile(file: any, filePath: any) {
    dispatch({ type: "clearFileState" });
    const fileState = {
      title: file.name,
      size: file.size,
      fileType: file.type || lookup(file.name)
    };
    dispatch({
      type: "openUploadFileModal",
      payload: { fileState, file, fileList: [file], isPaste: true, filePath }
    });
  }

  /**
   * 上传文件的起始入口，拖拽上传 input内部点击上传等， 会唤起确认框
   * @param file
   */
  function handleUploadSingleFile(file: any) {
    // 如果是通知类消息不调起上传
    if (!isAIChatSession(selectedSession) && selectedSession.isNotice) return;
    dispatch({ type: "clearFileState" });
    const fileState = {
      title: file.name,
      size: file.size,
      fileType: file.type || lookup(file.name) || ""
    };
    dispatch({
      type: "openUploadFileModal",
      payload: { fileState, file, fileList: [file] }
    });
  }
  function handleUploadMultiFile(files: any) {
    dispatch({ type: "clearFileState" });
    const realFiles = Array.prototype.slice.call(files);
    // const newFiles = realFiles.map((file) => {
    //     return {
    //         file: file,
    //         title: file.name,
    //         size: file.size,
    //         fileType: file.type || lookup(file.name) || '',
    //         fileId: nanoid(20),
    //     };
    // });
    dispatch({
      type: "openUploadFileModal",
      payload: { fileState: state.fileState, file: state.file, fileList: realFiles }
    });
  }

  async function handleUploadFile(files: any, multi?: string, filePath?: string) {
    if (!files || files.length === 0) {
      return;
    }
    if (filePath) {
      setIsMulti(false);
      const realList = await formatFileType(Array.from(files));
      handlePasteFile(realList[0], filePath);
      return;
    }
    if (files.length > 1 || multi) {
      setIsMulti(true);
      handleUploadMultiFile(files);
    } else {
      setIsMulti(false);
      const realList = await formatFileType(Array.from(files));
      handleUploadSingleFile(realList[0]);
    }
  }

  /**
   * 接收input内部的上传图片事件，不会唤起确认框
   * @param file
   * @param width
   * @param height
   */
  function handleUploadImg(imgState: typeof InitImgState, file: File, isOrigin?: boolean) {
    const message: Partial<ChatMessage> = buildImageMessageBody(
      imgState.base64,
      file.size,
      imgState.width,
      imgState.height,
      !!isOrigin
    );
    if (privateUser?.pin && privateUser?.pin !== "all") {
      message.to = { ...privateUser };
    }
    // 创建一个文件上传服务
    const task = createUploadTask(sessionId, file, {
      appKey: sessionId.startsWith("mt") ? "i2u1l800lb2qh65n" : appRuntimeEnv.fileService.imAppKey,
      bizType: getFileDownloadBzType(selectedSession),
      bizId: getFileDownloadBzId(selectedSession)
    });
    if (task) {
      // 发送临时消息到 dva 临时上传 message 中需要绑定 task 的 id\
      const chatMessage = initChatMessageInfo({
        selectedSession: selectedSession,
        currentEmployee: currentEmployee,
        message: message,
        task: task
      });
      task?.start();
      // const chatMessage = getChatMessageInfo(message, task);
      props.pushChatMessage({ sessionId, message: chatMessage });
    } else {
      log.warn("创建上传任务失败=======>");
    }
    // setTimeout(() => {
    //     dispatch({ type: 'clearFileState' });
    // }, 2000);
  }

  function handleMultiUploadImg(uploadList: any, isOrigin?: boolean) {
    uploadList?.forEach((item: any) => {
      if (item.file.size >= chatConfig["max-image-size"]) {
        handleSendFie(item.file);
      } else {
        handleUploadImg(item.imgState, item.file, isOrigin);
      }
    });
  }
  const handleReply = useCallback((props: any) => {
    const { replyText, replyUser, replyMessage } = props;
    setReplyMessage(replyMessage);
    // dispatch({ type: 'showReply', payload: { replyText, replyUser, replyMessage } });
  }, []);
  useEffect(() => {
    if (ChatEvent) {
      // 处理reply
      ChatEvent.on("chat-reply", handleReply);
    }
    return () => {
      if (ChatEvent) {
        ChatEvent.removeListener("chat-reply", handleReply);
      }
    };
  }, [handleReply]);
  // ChatEvent.on('chat-reply', handleReply);
  function handleShareJoySpace(data: any[]) {
    // console.log(data, 'datadatadatadata');
    if (!data || data.length === 0) {
      return 0;
    }
    if (data[0].from === "groupspace") {
      const linkIds = data.map((item) => {
        return item.id;
      });
      shareGroupspaceFiles({
        groupIds: [(selectedSession.info as GroupAttribute).gid],
        linkIds,
        linkType: 1
      }).then((res) => {
        const { code, status } = res;
        if (code !== "200") {
          message.error(status);
        }
        if (code === "200") {
          FocusSDK.emit("closeJoyspaceDocSelector");
        }
      });
    } else {
      data.forEach(async (item) => {
        const messageTypeOption = await getMessageTypeByText(item.url, httpMatchUrls, blackUrls);
        const chatMessage = await buildJoyspaceLinkMessageBody(
          item.url,
          messageTypeOption as JouspaceLinkTypeOption,
          [],
          selectedSession,
          undefined,
          item.permissionType
        );
        const message: Partial<ChatMessage> = initChatMessageInfo({
          selectedSession: selectedSession,
          currentEmployee: currentEmployee,
          message: chatMessage
        });
        props.pushChatMessage({ sessionId: sessionId, message: message });
      });
    }
  }

  // TODO: 这里需要优化一下写法 发送单个文件和多个文件
  function handleSendFie(file: any, filePath?: string, egovFile?: 0 | 1, tag = 0) {
    const { name, size, type: fileType, path } = file;
    const message: Partial<ChatMessage> = buildFileMessageBody(
      "",
      name,
      size,
      fileType,
      path || filePath,
      !!egovFile,
      tag
    );
    if (privateUser?.pin && privateUser?.pin !== "all") {
      message.to = { ...privateUser };
    }
    const task = createUploadTask(sessionId, file, {
      tag,
      egovFile,
      appKey: tag
        ? "SgnQ6d1TKKnnYGl7"
        : sessionId.startsWith("mt")
        ? "i2u1l800lb2qh65n"
        : appRuntimeEnv.fileService.imAppKey,
      bizType: getFileDownloadBzType(selectedSession),
      bizId: getFileDownloadBzId(selectedSession)
    });

    if (task) {
      const chatMessage = initChatMessageInfo({
        selectedSession: selectedSession,
        currentEmployee: currentEmployee,
        message: message,
        task: task
      });
      // console.log(chatMessage, task, 'handleSendFie', file);
      // 发送临时消息到 dva 临时上传 message 中需要绑定 task 的 id
      props.pushChatMessage({ sessionId, message: chatMessage });
    } else {
      log.warn("创建上传任务失败=======>", JSON.stringify(file));
    }
    setIsEgovFile(false);
  }

  function filesClassify(selectedFiles: any): Promise<any> {
    return new Promise((resolve) => {
      let images: any = [];
      let files: any = [];
      selectedFiles.forEach(async (item: any) => {
        const isImage = await filterImages(item.file);
        if (isImage) {
          // console.log('image');
          images.push(item);
        } else {
          // console.log('file');
          files.push(item);
        }
      });
      resolve({ images, files });
    });
  }
  async function beforeSendMultiFile(selectedFiles: any) {
    const { images, files } = await filesClassify(selectedFiles);
    // console.log(images, files);
    if (images.length) {
      // console.log('要发送的图片数组', files);
      let tempList: any[] = [];
      images.forEach((imageItem: any) => {
        const promise = dealImagesData(imageItem.file);
        tempList.push(promise);
      });
      Promise.all(tempList).then((result) => {
        // console.log('result', result);
        result.length &&
          result.forEach(async (data) => {
            handleUploadImg(data.imgState, data.file);
          });
      });
    }
    if (files.length) {
      // console.log('要发送的文件数组', files);
      files.forEach((item: any) => {
        handleSendFie(item.file, "", item.egovFile, item.fileTag);
      });
    }
  }

  async function sendFile(selectedFiles?: any) {
    dispatch({ type: "closeUploadFileModal" });
    if (isMulti) {
      beforeSendMultiFile(selectedFiles || []);
    } else {
      // console.log('state.file', state.file);
      const tempFile = state.file;
      const isImage = await filterImages(tempFile);
      if (isImage) {
        const data = await dealImagesData(tempFile);
        // console.log('data', data);
        handleUploadImg(data.imgState, data.file);
        return;
      }
      await handleSendFie(tempFile, "", selectedFiles[0].egovFile, selectedFiles[0].fileTag);
    }
    // setTimeout(() => {
    //     dispatch({ type: 'clearFileState' });
    // }, 2000);
  }
  async function doSendFile(selectedFiles?: any) {
    if (state.filePath) {
      sendFileByPaste(selectedFiles, state.filePath);
    } else {
      sendFile(selectedFiles);
    }
  }
  async function sendFileByPaste(selectedFiles: any, filePath: any) {
    // console.log("selectedFiles", selectedFiles, state.file);
    dispatch({ type: "closeUploadFileModal" });
    await handleSendFie(state.file, filePath);
  }

  const canDragSession = useMemo(() => {
    return !isAINoticeSession(selectedSession);
  }, [selectedSession]);

  const [fileDrag, setFileDrag] = useState(false);
  const dropOption =
    config[ChatConfig.CHAT_MESSAGE_DRAG_FILE] && canDragSession
      ? {
          onDragEnter: handleDragEnter,
          onDragOver: handleDragOver,
          onDrop: handleDrop
        }
      : {};

  const fileDragPart = useMemo(() => {
    if (!selectedSession.sessionId || !fileDrag) {
      return null;
    }
    if (isBannedPostGroupSession(selectedSession) && isGroupOrdinary(groupRosterIdentity)) {
      return (
        <div className="main-part-mask" onDragLeave={handleDragLeave}>
          <div className="inner">
            <ExclamationOutlined className="exclamation" style={{ color: "rgba(245,34,45,1)" }} />
            <div>{t("drag_here_warning")}</div>
          </div>
        </div>
      );
    }
    return (
      <div className="main-part-mask" onDragLeave={handleDragLeave}>
        <div className="inner">{t("drag_here_to_sb").replace("%s", selectedSession.info.name)}</div>
      </div>
    );
  }, [selectedSession, fileDrag, t, groupRosterIdentity]);

  const showTag = useMemo(() => {
    return (
      <div style={{ display: "flex" }}>
        {showTagList.map((item: any, index: number) => {
          const ext = typeof item.ext === "string" ? JSON.parse(item.ext) : {};
          const { from = {} } = ext;
          const { fUserKey = "" } = ext.body;
          const key = fUserKey || `${from.pin}:${from.app}:${from.teamId}`;
          const remark = findUserRemarkBySession(key, selectedSession);
          const date = isYearBefore(item.messageTime) ? "YYYY年M月D日" : "M月D日";
          let content = item.messageContent;
          if (content.includes(t("quill-old-version-tip"))) {
            content = removeFirstOccurrence(content, t("quill-old-version-tip"));
          }
          return (
            <div key={index} className="tag-marquee">
              <span style={{ color: "#1686FF" }}>
                {`${item.realName}${remark ? `（${remark}）` : ""}`}
              </span>
              <span style={{ opacity: "0.5" }}>
                {`（${dayjs(item.messageTime).format(date)}）：`}
              </span>
              <span style={{ color: "#232930" }}>{content}</span>
            </div>
          );
        })}
      </div>
    );
  }, [showTagList, selectedSession]);

  const showWebview = useMemo(() => {
    return isAIChatSession(selectedSession) && currentAIRobot?.type === "video";
  }, [selectedSession, currentAIRobot?.type]);

  if (!loadAllSessionListEnd) {
    return (
      <div className="chat-main-container">
        <div className="main-part">
          <Loading />
        </div>
      </div>
    );
  }

  // eslint-disable-next-line array-callback-return

  return (
    <div className={`chat-main-container ${isAIChatSession(selectedSession) ? "smallAI" : "grey"}`}>
      {sessionId && (
        <div className="main-part" {...dropOption}>
          <div className="main-header">
            {![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
              selectedSession.sessionType
            ) ? (
              <SessionHeader session={selectedSession} setCallBack={setCallBack} />
            ) : (
              <div />
            )}
          </div>
          {isAIChatSession(selectedSession) && showWebview ? (
            <div className="main-webview-wrap">
              <div className="main-webview-mark" />
              <webview
                className="main-webview"
                id="airobot"
                webpreferences="contextIsolation=no,sandbox=false"
                style={{width: "100%" }}
                src={currentAIRobot?.dmUrl}
              />
            </div>
          ) : null}

          <div className="main-body" style={{ position: "relative" }}>
            {isAINoticeSession(selectedSession) && !isAIChatSession(selectedSession) && (
              <AINoticeTabHeader />
            )}
            {isBusinessGroup(selectedSession) && (
              <TopNoticeCard2Chat
                businessId={(selectedSession.info as any).businessId}
                businessType={(selectedSession.info as any).business}
              />
            )}
            {selectedSession.isGroup &&
              showMarquee &&
              showTagList.length !== 0 &&
              showTagList[0]?.groupId === sessionId && (
                <div
                  className="msg-list"
                  onClick={(e) => {
                    Bus.emit("chat:tagList", {
                      visible: true
                    });
                  }}
                >
                  <span className="tagIcon">
                    <IconFont
                      style={{
                        color: "#EE0A24",
                        width: 14,
                        height: 14
                      }}
                      type="iconic_app_mark_solid_left"
                    />
                  </span>
                  <Marquee speed={30} pauseOnHover delay="1s" startPlay={startPlay}>
                    {showTag}
                  </Marquee>
                </div>
              )}
            <MessageBoxContainer />
            {/* 暂存 */}
            {selectedSession.isGroup && <GroupCard message={selectedSession} />}
            {isAIChatSession(selectedSession) && <QuestionAction />}
          </div>
          {/* tj:非会话模式隐藏输入框，解决切换消息类型未保存草稿 */}
          <div
            id={editorMode === "old" ? "main-box" : "main-box-without-border"}
            className={
              [
                SessionType.SINGLE,
                SessionType.SECRET_SINGLE,
                SessionType.GROUP,
                SessionType.MEETING_GROUP,
                SessionType.LIVE_MEETING_GROUP
              ].includes(selectedSession.sessionType) || isAIChatSession(selectedSession)
                ? messageInputFocus
                  ? "main-footer editing"
                  : "main-footer"
                : "dn"
            }
          >
            {selectMore ? (
              selectedSession.isSecret ? (
                <DestroyMessage />
              ) : type === "addUser" ? (
                <ForwardSelect />
              ) : (
                <Forwarding />
              )
            ) : editorMode === "old" ? (
              <MessageInput
                uploadFile={handleUploadFile}
                uploadImg={throttle(handleUploadImg, 200)}
                uploadMultiImg={throttle(handleMultiUploadImg, 200)}
                sendJoyspaceMessage={handleShareJoySpace}
              />
            ) : (
              <MessageInputV2
                uploadFile={handleUploadFile}
                uploadImg={throttle(handleUploadImg, 200)}
                uploadMultiImg={throttle(handleMultiUploadImg, 200)}
                sendJoyspaceMessage={handleShareJoySpace}
              />
            )}
          </div>
          {/* 拖拽上传 */}
          {!selectedSession.isNotice && fileDrag && fileDragPart}
          <UpLoadFile
            visible={state.fileUploadModalVisible}
            onCancel={closeUploadFileModal}
            onClick={doSendFile}
            isMulti={isMulti}
            file={state.file}
            fileList={state.fileList}
            title={state.fileState.title}
            size={state.fileState.size}
            fileType={state.fileState.fileType}
            isEgovFile={isEgovFile}
            onEgovFileCheckedChange={handleEgovFileToggle}
            dualNet={
              ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(
                selectedSession.sessionType
              )
            }
          />
        </div>
      )}
      {/* 未点击任何聊天时，右侧展示占位图 */}
      {!sessionId && allSessionListLength >= 0 && (
        <div className="default msg-skelecton">
          <Empty image={default_chat_png} description="信息安全、高效协同" imageStyle={style} />
        </div>
      )}
    </div>
  );
}

function mapStateToProps({ user, chat }: { user: any; chat: ChatState }) {
  const {
    allSessionList,
    selectedSession,
    currentEmployee,
    selectMore,
    type,
    loadAllSessionListEnd,
    messageInputFocus,
    showTagList,
    privateUser,
    currentAIRobot
  } = chat as ChatState;
  return {
    allSessionListLength: allSessionList?.length,
    selectedSession,
    currentEmployee,
    selectMore,
    type,
    loadAllSessionListEnd,
    messageInputFocus,
    showTagList,
    privateUser,
    currentAIRobot,
    editorMode: user.editorMode
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    setShowTagList(data: { showTagList: any }) {
      dispatch({ type: "chat/setShowTagList", payload: data });
    },
    setEditorMode: (data: any) => {
      dispatch({ type: "user/setEditorMode", payload: data });
    }

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatMain);
